import styled from 'styled-components';

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SectionContainer = styled.div`
  margin-bottom: 6px;
`;

const SectionHeader = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
`;

const GridContainer = styled.div`
  display: grid;
  gap: 6px;

  ${(props) => props.gridType === 'personal' && `
    grid-template-columns: repeat(2, 1fr);
  `}

  ${(props) => props.gridType === 'nutrition' && `
    grid-template-columns: repeat(4, 1fr);
  `}

  ${(props) => props.gridType === 'preferences' && `
    grid-template-columns: 1fr;
  `}

  ${(props) => props.gridType === 'logistics' && `
    grid-template-columns: repeat(3, 1fr);
  `}

  ${(props) => props.gridType === 'additional' && `
    grid-template-columns: 1fr;
  `}
`;

export {
  FormContainer,
  SectionContainer,
  SectionHeader,
  GridContainer,
};
